<template>
  <div>
    <div class="pop_container">
      <div class="pop_left">
        <div class="pop_title">{{name}}<span></span></div>
        <div class="pop_loacl">
          {{location}}
<!--          坐落地点：厦门市思明区大同路145号之一的“商勋别墅”-->
        </div>
        <div class="pop_introduce">
          {{introduction}}
<!--          简介：建于1917年，是一栋典型的中西合壁的闽南民居，因主人苏敬廷在清代获得“顶戴商勋”的光荣称号而扬名。小庭院里绿树成荫，奇石花木掩映其中，两层欧式红砖楼房清幽恬静，与墙外热闹喧嚣的街巷宛若天壤，是厦门老市区独树一帜的别墅。1926年修建大同路时，为了避让这座豪宅，还特意在附近折了一个弯。大同路建成后，这座别墅在隐匿于街市的背后。-->
        </div>
        <div class="pop_range">
          <!-- 保护范围：祭祖堂和宗亲会馆建筑四周向外延伸10米。 -->
        </div>
        <div class="pop_time">
          <!-- 2009年，江夏堂被福建省人民政府公布为第七批省级文物保护单位。 -->
        </div>
      </div>

      <div class="pop_right">
        <div class="introduce" style="background-color: rgba(255, 255, 255, 0)">
          <div id="pop_1">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(val,key) in regionImg" :key="key">
                  <img :src="val" width="100%" height="100%"/>
                </div>
              </div>
              <!-- <div class="swiper-pagination"></div> -->
            </div>
          </div>
        </div>
        <div class="introduce_wrapper">
          <div class="domestic_wrapper2">
            <div class="domestic domestic_selected">街区照片</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/swiper.min.css";
import Swiper from "@/assets/js/swiper.min.js";
export default {
  props: {},
  data() {
    return {
      name:"",
      location:"",
      introduction:"",
      regionImg:[],
      nameArray:[
        "厦门总工会旧址",
        "新街礼拜堂",
        "江夏堂",

        "大清厦门一等邮局遗址",
        "阮旻锡夕阳寮隐居处遗址",
        "厦门各界抗敌后援会会址",

        "陈化成故居",
        "庆让堂",
        "大华饭店旧址",

        "厦大大旅社旧址",
        "大千旅社旧址",
        "同英布店旧址",

        "台湾工会旧址",
        "兰琴古厝",
        "鹭江宾馆",
        "商勋别墅",
        "中山路169号"

      ],
      locationArray:[
        '位于福建省厦门市思明区鹭江街道大同社区大同路土堆巷68号,1961年由福建省人民委员会公布为第一批省级文物保护单位。',
        '位于思明区台光街29号，1982年由厦门市政府公布为第二批市级文物保护单位，2005年由福建省政府公布为第六批省级文物保护单位。',
        '位于思明区钱炉灰埕2号文安小学内，为清末武科状元黄培松于宣统二年（1910年）至1918年建造，系黄氏大宗祠的祭祖堂。',
        '位于福建省厦门市思明区鹭江街道鹭江道社区海后路58号，2004年由厦门市人民政府公布为第五批市级文物保护单位。',
        '位于思明区水仙路竹寮巷12号，时代为清代，1982年被公布为市级文物保护单位。',
        '又称保生堂，位于思明区定安路71号，1961年被公布为厦门市文物保护单位。',
        '位于思明区仁安社区草埔巷9号，1961年被公布为市级文物保护单位，2001年被公布为厦门涉台文物古迹。',
        '位于思明区中华街道中山社区天一楼巷21号，2013年被公布为思明区一般不可移动文物，2020年被公布为第七批厦门市文物保护单位。',
        '位于思明区中山路151-155号，2020年被公布为第七批厦门市文物保护单位。',
        '位于思明区思明西路62-64号，2020年被公布为第七批厦门市文物保护单位。',
        '位于福建省厦门市思明区鹭江街道大同社区海后路36-40号，2013年被公布为思明区一般不可移动文物，2020年被公布为第七批厦门市文物保护单位。',
        '位于福建省厦门市思明区鹭江街道大同社区大同路69号，大同路与横竹路转角，十字路口西北处，2013年被公布为思明区一般不可移动文物，2020年被公布为第七批厦门市文物保护单位。',
        '位于中华街道新华路40号，2007年被公布为厦门市第二批涉台文物古迹。台湾公会是一个为在厦门台胞提供帮助、服务的民间性会馆组织。',
        '兰琴古厝高堂大瓦，水榭歌台，曲径幽通，庭院深深，系厦门现今保存最完整的一座典型闽南风格古建筑。',
        '鹭江宾馆位于厦门市思明区区鹭江道54号，民国时期。它为中间七层，两侧六层的临街中西合璧式建筑。',
        '位于大同路145号之一的“商勋别墅”建于1917年，是一栋典型的中西合壁的闽南民居，因主人苏敬廷在清代获得“顶戴商勋”的光荣称号而扬名。',
        '古时该处设有铳局，有局外。局内之分，局外称局口。本厅口、太子巷、桂州堆均其路段旧称或浴称。',


      ],
      introductionArray:[
        "该址建于二十世纪二十年代，系主体二层、局部三层的西式红砖建筑，占地面积170平方米，砖木结构，1999年重修时楼面改为混凝土结构。旧址现已辟为厦门工人运动陈列馆。该址系大革命时期厦门总工会的机关所在地，1927年1月24日，共产党员罗扬才、杨世宁等人在此成立厦门总工会。总工会成立不久，会员即发展到二万多人，建立起十多个工人党支部，并成功地领导了提高工人劳动待遇的“二五加薪”斗争。同年4月9日凌晨，国民党右派发动反革命政变，罗扬才、杨世宁被逮捕。6月2日，罗、杨二人被秘密杀害于福州，工会组织遭受了严重破坏。从此，厦门的工人运动被迫转入地下活动。",
        "1928 年年久修坍塌,遂于1933年重建，至1935年竣工。由于地处市区东边的新街仔，故取名“新街礼拜堂”。它是我国最早供华人使用的基督教堂，因此被称为“中华第一圣堂”。新街礼拜堂现存建筑系砖石木结构，罗马式建筑风格，典雅庄重。现占地总面积约 1214 平方米。礼拜堂主楼占地面积近380平方米，可容纳400人同时做礼拜。礼拜堂由上海名师设计，惠安石匠和温州木匠共同建造完工，耗资白银三万二千两。木材选用南洋进口柚木。建造资金全部由厦门信众和东南亚的华侨信众捐资募集。",
        "2004年由厦门市人民政府公布为第五批市级文物保护单位，2007年由厦门市人民政府公布为第二批涉台文物古迹，2009年由福建省政府公布为第七批省级文物保护单位。江夏堂坐南朝北，占地面积373平方米，为重檐歇山顶，抬梁砖石木结构。原有祖堂、宗贤堂、拜庭、紫云屏、宗亲会馆、江夏小学、望海亭及花园组成。今仅存祭祖和宗亲会馆两建筑。",

        "清光绪二十三年（1897年），“厦门大清邮务总局”在此创办，这是中国最早的对外营业的邮局之一，为中国近代国家邮政的开端。1911年海关与邮局分开设立，邮务总局改称“大清厦门一等邮局”，这是福建唯一的一等甲级邮局。今海后路58号建筑系1972年重建的邮政综合楼，2002年，邮局按大清厦门一等邮局的建筑风貌进行改造装修。大清厦门一等邮局建筑今虽已不存，但遗址作为厦门以及中国邮政百年历史的象征，仍具有纪念意义。",
        "阮旻锡(1627-?)，字畴生，厦门人，著名诗人，曾协助郑成功抗清。清康熙十九年（1680）清军攻占厦门。1683年他在北京削发为僧，晚年回厦门隐居著书立说，所著《海上见闻录》是研究郑成功史迹的重要文献。该址实际上是一处花岗岩岩厦，向南向西均通透，长35米，宽24米，高6.5米。原有夕阳寮的建筑已毁，仅存崖壁上方孔多处（搭架梁椽）和“水天一色”、“望石”、“康熙庚寅冬”等摩崖题刻，其中“水天一色”摩崖石刻在岩厦东北侧的山崖上，长约3.6米，宽约0.5米，阴刻楷书，该遗址对研究厦门地方史和名人有较重要的意义。",
        "建成于1929年，系台籍妇产科医生黄仔尾的诊所(名保生堂)及私人住宅。1937年“七·七”事变后，日军发动全面侵华战争，亡国灭种的危机空前，全国救亡运动更加风起云涌，7月28日“福建省各界抗敌后援会厦门分会”在此宣布成立。后援会下设宣传、募捐、慰劳、救护、救济等十一工作部，后合并为七个工作团，其中慰劳和宣传工作团为中共厦门市委所领导，其抗日救亡工作一直坚持到1938年5月厦门沦陷。该址是厦门各界爱国抗敌活动的珍贵见证物，对研究厦门人民的抗战史很有价值。",

        "该故居是陈化成于清道光二十一年（1831）升任福建水师提督驻厦门时所购置，是一座由主体建筑及左右厢房、庭院、天井、院墙组成的闽南传统建筑，建筑面积400平方米，院内有旗杆石座，高1.80米。故居内还保存陈化成当年使用的石板床、楠木橱柜等。此故居是纪念和研究陈化成不可多得的珍贵实物。\n" +
        "陈化成（1776-1842），字业章，号莲峰，水师出生，历任参将、副将、总兵、厦门水师提督，爱国将领。曾捐助修建官署、庙宇、书院，并捐刻道光版《厦门志》。鸦片战争时，他调任江南提督，驻防上海吴淞口。1842年英军进攻吴淞口，他坐镇西炮台指挥战斗，后因两江总督牛鉴临阵脱逃孤军无援战死炮台。随后陈化成灵柩运回厦门安葬于金榜山麓。\n",
        "该建筑为一座左右两端为菱形楼体，中间有半圆形楼体，实际上为阳台的三层洋楼建筑，半圆形阳台用仿古希腊陶立克式水泥圆柱支撑，它的墙体下部有闽南传统花岗岩条石构筑，并雕刻有花卉图案，左右两侧的菱形楼体及中间的廊道均用红砖方柱支撑，此楼装饰较为精美，它的水泥梁的正立面有狮子山水立体雕塑装饰，它的窗为花岗岩条石，窗额上有西洋花卉装饰，大厅内屏风上有花卉木雕。它对研究中西建筑文化的融合具有一定的价值。",
        "该建筑于1933年建成，总建筑面积1200㎡，第二年开始作为大华饭店经营，是厦门当时有电梯的三座高级饭店之一，是厦门当时经济社会发展的见证。",

        "该建筑1935年建成成，占地面积310平方米，总建筑面积1700平方米，原先开设厦大大旅社，日本侵厦期间改为柏原旅社。1945年8月15日，抗战胜利。当年9月28日，侵厦日军在鼓浪屿举办签字投降仪式。10月3日，福建省保安司令部副司令严泽元与时任厦门市市长黄天爵由石码乘船抵厦，来到柏原旅社，接受日军投降，完成厦门市的接管。",
        "该建筑为缅甸侨商曾上苑于上世纪二、三十年代所建，原名大千旅社，现为春光旅社，是厦门当时规模较大的旅社之一，自建成至今一直作为旅社使用。四层砖混中式建筑，坐东北朝西南，建筑面积约1300平方米。",
        "该建筑为上世纪30年代所建，坐东北朝西南，4层砖混中西合璧骑楼式，建筑面积约1400平方米。",
        "1936年改名为“台湾居留民会”，抗战胜利后改名为“台湾同乡会”，二十世纪五十年代中期停止活动。台湾公会始建于1906年，第二年迁至和凤宫，1930年迁现址重建。旧址是一座三层中西合璧的西洋楼，有围墙、院门。正立面有六根圆柱直达楼顶，柱头上瓜棱状装饰，大门门额上有一匾刻“台湾公会”四个大字，二三楼间的外墙中间、楼冠有凤鸟和西洋花卉等装饰。",
        "古厝坐落于厦门市繁华的中山路段，提供配套设施齐全的高档客房及休闲茶舍，毗邻轮渡、环岛路、鼓浪屿、厦大、南普陀等旅游景区。厝中盘桓小憩，恍若阳春召烟景。渊明诗云“结庐在人境，心远地自偏”。",
        "方向222°，总面宽50米，总进深35米。楼身为西洋式，下层用花岗岩砌筑，顶为中国传统建筑屋顶，盖琉璃瓦。它左右对称，用料讲究，建造精致，是厦门近现代建筑精品。鹭江宾馆是福建省首家旅游的涉外四星级宾馆。",
        "小庭院里绿树成荫，奇石花木掩映其中，两层欧式红砖楼房清幽恬静，与墙外热闹喧嚣的街巷宛若天壤，是厦门老市区独树一帜的别墅。1926年修建大同路时，为了避让这座豪宅，还特意在附近折了一个弯。大同路建成后，这座别墅在隐匿于街市的背后。",
        " "


      ],
      regionImgArray:[
        [require("../../assets/img/wbdw/xmzghjz.png")],
        [require("../../assets/img/wbdw/xjlbt.jpeg")],
        [require("../../assets/img/wbdw/jxt.png")],
        [require("../../assets/img/wbdw/dqxmdyyjyz.jpg")],
        [require("../../assets/img/wbdw/ryxyyjyz.png")],
        [require("../../assets/img/wbdw/xmgjkdhyhjj.jpg")],
        [require("../../assets/img/wbdw/chcgj.png")],
        [require("../../assets/img/wbdw/qrst.png")],
        [require("../../assets/img/wbdw/dhfdjz.png")],
        [require("../../assets/img/wbdw/xdlsjz.png")],
        [require("../../assets/img/wbdw/dqlsjz.png")],
        [require("../../assets/img/wbdw/tybdjz.png")],
        [require("../../assets/img/wbdw/twggjz.png")],
        [require("../../assets/img/wbdw/lqgc.jpg")],
        [require("../../assets/img/wbdw/ljbg.jpg")],
        [require("../../assets/img/wbdw/sybs.jpg")],
        [require("../../assets/img/wbdw/zsl169h.jpg")],
      ]
    };
  },
  components: {},
  mounted() {
    new Swiper("#pop_1 .swiper-container", {
      watchSlidesProgress: true,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      loopedSlides: 3,
      autoplay: true,
      spaceBetween: -70,
    });
  },
 props: {
    id: Number // 声明一个名为 id 的 props，类型为 Number
  },
  created() {
    // let i = this.$route.query.id;
    let i = this.id;
    if(!i){
      i=0;
    }

    this.name = this.nameArray[i-1];
    this.location = this.locationArray[i-1];
    this.introduction = this.introductionArray[i-1];
    this.regionImg = this.regionImgArray[i-1];


  },
  methods: {
    // closePop() {
    //   this.$emit("closePop", "");
    // },
  },
};
</script>
<style scoped >
#pop_1 {
  width: 100%;
  height: 199px;
  margin: 0 auto;
}

#pop_1 .swiper-container {
  width: 100%;
  margin: 0px auto;
}

#pop_1 .swiper-slide {
  width: 400px;
  height: 200px;
}
#pop_1 .swiper-slide-next{
  transform: scale(.9);
}
#pop_1 .swiper-slide-prev{
  transform: scale(.9);
}
</style>

<style scoped src="@/assets/css/pop.css"></style>